import React from 'react';
import Helmet from 'react-helmet';
import ChromeIcon from '../assets/images/chrome-icon.png';
import FirefoxIcon from '../assets/images/firefox-icon.png';
import ChromeMenu from '../assets/images/chrome-menu.png';
import FirefoxMenu from '../assets/images/firefox-menu.png';
import Addons from '../assets/images/addons.png';
import Extensions from '../assets/images/extensions.png';
import AddRemove from '../assets/images/addremove.png';
import ChromeInstruction from '../assets/images/chrome-instruction.jpg';
import { lang } from '../lang_uninstall';

const Uninstall = () => (
  <div>
    <Helmet>
      <title>{lang.title}</title>
      <meta name="description" content={`${lang.description}`} />
    </Helmet>

    <div className="main-container -uninstall">
      <h1 className="uninstall-head">{lang.uninstall}</h1>
      <div className="uninstall-alert">{lang.important}</div>
      <div className="uninstall-container">
        <h2 className="uninstall-bodyhead">
          <img className="image" src={ChromeIcon} alt="chrome-icon" />
          <span className="head">{lang.remove_steps}</span>
        </h2>
        <ol className="uninstall-list">
          <li>
            <p>{lang.remove_step1}</p>
          </li>
          <li>
            <p>{lang.remove_step2}</p>
            <img className="chrome-instruction" src={ChromeInstruction} alt="chrome instruction" />
          </li>
          <li>
            <p>{lang.remove_step3}</p>
          </li>
          <li>
            <p>
              A confirmation dialog will appear, click '<strong>Remove</strong>
              '.
            </p>
          </li>
        </ol>
        <p className="note-subhead">{lang.turn_off}</p>

        <h2 className="uninstall-bodyhead">
          <img className="image" src={FirefoxIcon} alt="firefox-icon" />
          <span className="head">{lang.remove_ff}</span>
        </h2>

        <ol className="uninstall-list">
          <li>
            <p>{lang.remove_ff_1}</p>
          </li>
          <li>
            <p>{lang.remove_ff_2}</p>
          </li>
          <li>
            <p>{lang.remove_ff_3}</p>
          </li>
        </ol>
      </div>
    </div>
  </div>
);

export default Uninstall;



// WEBPACK FOOTER //
// ./src/pages/Uninstall.js